<template>
  <v-dialog v-model="dialog" persistent max-width="350px">
    <v-card>
      <v-card-title>Confirm</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn color="primary" depressed @click="agree()" class="text-none">
          {{ okText }}
        </v-btn>
        <v-btn outlined @click="cancel()" class="text-none">
          {{ cancelText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Ref: https://qiita.com/ta1nakamura/items/f844dd2437af8ecc5674
  data: () => ({
    dialog: false,
    resolve: null,
    message: null,
    okText: null,
    cancelText: null,
  }),
  methods: {
    open(message, okText = 'OK', cancelText = 'Cancel') {
      this.dialog = true
      this.message = message
      this.okText = okText
      this.cancelText = cancelText
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
}
</script>
